/* =====================================================================
   PLASTARA — GLOSS  ·  store.js
   Zero dependencies. Everything degrades to a working HTML store.
   ===================================================================== */
(function () {
  "use strict";

  var REDUCED = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var money = window.PLASTARA_MONEY_FORMAT || "${{amount}}";
  var ROOT = window.PLASTARA_ROOT || "/";

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    var n = (cents / 100);
    var parts = n.toFixed(2).split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var out = whole + "." + parts[1];
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(money)) {
      out = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, out);
    }
    return money.replace(/\{\{\s*amount\s*\}\}/, out);
  }

  /* ---------------------------------------------------------------- toast */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2600);
  }

  /* ------------------------------------------------------------- reveals */
  function reveals() {
    if (REDUCED || !("IntersectionObserver" in window)) return;
    var items = $$("[data-rv]");
    if (!items.length) return;
    document.documentElement.classList.add("fx");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
    // safety: nothing may stay hidden
    setTimeout(function () {
      $$("[data-rv]").forEach(function (el) { el.classList.add("is-in"); });
    }, 3500);
  }

  /* -------------------------------------------------------- announcement */
  function announce() {
    var bar = $("[data-announce]");
    if (!bar) return;
    var msgs = $$(".announce__msg", bar);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-on");
    }, 4200);
  }

  /* ----------------------------------------------------------- mobile nav */
  function mobileNav() {
    var nav = $("[data-mnav]");
    if (!nav) return;
    function set(open) {
      nav.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    }
    $$("[data-mnav-open]").forEach(function (b) { on(b, "click", function () { set(true); }); });
    $$("[data-mnav-close]").forEach(function (b) { on(b, "click", function () { set(false); }); });
    $$("a", nav).forEach(function (a) { on(a, "click", function () { set(false); }); });
    on(document, "keydown", function (e) { if (e.key === "Escape") set(false); });
  }

  /* --------------------------------------------------------- search panel */
  function searchPanel() {
    var p = $("[data-search]");
    if (!p) return;
    function set(open) {
      p.classList.toggle("is-open", open);
      if (open) { var i = $("input[type=search]", p); if (i) setTimeout(function () { i.focus(); }, 120); }
    }
    $$("[data-search-open]").forEach(function (b) { on(b, "click", function () { set(true); }); });
    $$("[data-search-close]").forEach(function (b) { on(b, "click", function () { set(false); }); });
    on(p, "click", function (e) { if (e.target === p) set(false); });
    on(document, "keydown", function (e) { if (e.key === "Escape") set(false); });
  }

  /* -------------------------------------------------------------- accordions */
  function accordions() {
    $$(".acc").forEach(function (acc) {
      var q = $(".acc__q", acc), a = $(".acc__a", acc);
      if (!q || !a) return;
      if (acc.classList.contains("is-open")) a.style.maxHeight = a.scrollHeight + "px";
      on(q, "click", function () {
        var open = acc.classList.toggle("is-open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
      });
    });
  }

  /* ------------------------------------------------------------ cart drawer */
  var drawer = null;

  function drawerSet(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }

  function updateCartCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.setAttribute("data-count", n);
    });
  }

  function shipBar(total) {
    var bar = $("[data-ship-bar]");
    if (!bar) return;
    var goal = parseInt(bar.getAttribute("data-goal") || "0", 10);
    if (!goal) { bar.style.display = "none"; return; }
    var fill = $(".ship-bar__fill", bar), txt = $(".ship-bar__t", bar);
    var pct = Math.min(100, (total / goal) * 100);
    if (fill) fill.style.width = pct + "%";
    if (txt) {
      txt.textContent = total >= goal
        ? (bar.getAttribute("data-done") || "Free shipping unlocked")
        : (bar.getAttribute("data-away") || "{amount} away from free shipping")
            .replace("{amount}", formatMoney(goal - total));
    }
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    shipBar(cart.total_price);

    var body = $("[data-cart-items]");
    var foot = $("[data-cart-foot]");
    var empty = $("[data-cart-empty]");
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = "";
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="" loading="lazy" width="74" height="92">'
        : "";
      var variant = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== "Default Title"; })
        .map(function (o) { return o.value; }).join(" · ");
      return '' +
        '<div class="citem" data-line="' + it.key + '">' +
          '<div class="citem__img">' + img + '</div>' +
          '<div>' +
            '<a class="citem__t" href="' + it.url + '">' + it.product_title + '</a>' +
            (variant ? '<div class="citem__v">' + variant + '</div>' : '') +
            '<div class="qty">' +
              '<button type="button" data-line-minus aria-label="Decrease">&minus;</button>' +
              '<input type="number" min="0" value="' + it.quantity + '" data-line-qty aria-label="Quantity">' +
              '<button type="button" data-line-plus aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div>' +
            '<div class="citem__p">' + formatMoney(it.final_line_price) + '</div>' +
            '<button type="button" class="citem__rm" data-line-remove>' +
              (window.PLASTARA_STR && window.PLASTARA_STR.remove || "Remove") +
            '</button>' +
          '</div>' +
        '</div>';
    }).join("");

    var tot = $("[data-cart-total]");
    if (tot) tot.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.textContent : "";
    if (btn) { btn.setAttribute("aria-disabled", "true"); btn.textContent = "…"; }
    return fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || "Could not add to cart");
        return d;
      });
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      drawerSet(true);
      return cart;
    }).catch(function (e) {
      toast(e.message || "Could not add to cart");
    }).then(function () {
      if (btn) { btn.removeAttribute("aria-disabled"); btn.textContent = label; }
    });
  }

  function cart() {
    drawer = $("[data-drawer]");

    $$("[data-drawer-open]").forEach(function (b) {
      on(b, "click", function (e) {
        if (!drawer) return;          // no JS drawer -> let the link go to /cart
        e.preventDefault();
        drawerSet(true);
        fetchCart().then(renderCart).catch(function () {});
      });
    });
    $$("[data-drawer-close]").forEach(function (b) { on(b, "click", function () { drawerSet(false); }); });
    if (drawer) on($(".dr__scrim", drawer), "click", function () { drawerSet(false); });
    on(document, "keydown", function (e) { if (e.key === "Escape") drawerSet(false); });

    // line item controls (delegated)
    on(document, "click", function (e) {
      var row = e.target.closest && e.target.closest("[data-line]");
      if (!row) return;
      var key = row.getAttribute("data-line");
      var input = $("[data-line-qty]", row);
      var q = parseInt(input && input.value || "1", 10);
      if (e.target.closest("[data-line-plus]")) { changeLine(key, q + 1); }
      else if (e.target.closest("[data-line-minus]")) { changeLine(key, Math.max(0, q - 1)); }
      else if (e.target.closest("[data-line-remove]")) { changeLine(key, 0); }
    });
    on(document, "change", function (e) {
      if (!e.target.matches("[data-line-qty]")) return;
      var row = e.target.closest("[data-line]");
      if (!row) return;
      changeLine(row.getAttribute("data-line"), Math.max(0, parseInt(e.target.value || "0", 10)));
    });

    // quick add from cards
    on(document, "click", function (e) {
      var b = e.target.closest && e.target.closest("[data-quick-add]");
      if (!b) return;
      e.preventDefault();
      addToCart(b.getAttribute("data-quick-add"), 1, b);
    });
  }

  /* ------------------------------------------------------------ quantity */
  function qtyWidgets() {
    on(document, "click", function (e) {
      var box = e.target.closest && e.target.closest(".qty");
      if (!box || box.closest("[data-line]")) return;
      var input = $("input", box);
      if (!input) return;
      var v = parseInt(input.value || "1", 10);
      if (e.target.closest("[data-q-plus]")) input.value = v + 1;
      if (e.target.closest("[data-q-minus]")) input.value = Math.max(1, v - 1);
    });
  }

  /* ----------------------------------------------------------- pdp gallery */
  function gallery() {
    var gal = $("[data-gallery]");
    if (!gal) return;
    var thumbs = $$("[data-thumb]", gal);
    var slides = $$("[data-slide]", gal);
    function show(id) {
      slides.forEach(function (s) { s.classList.toggle("is-on", s.getAttribute("data-slide") === id); });
      thumbs.forEach(function (t) { t.setAttribute("aria-current", t.getAttribute("data-thumb") === id ? "true" : "false"); });
    }
    thumbs.forEach(function (t) {
      on(t, "click", function () { show(t.getAttribute("data-thumb")); });
    });
  }

  /* ---------------------------------------------------------- variant picker */
  function variants() {
    var form = $("[data-product-form]");
    if (!form) return;
    var data = $("[data-variants]");
    if (!data) return;
    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = $("[data-variant-id]", form);
    var atc = $("[data-atc]", form);
    var priceEls = $$("[data-price]");        // buy box + sticky mobile bar
    var mAtc = $("[data-mbuy-add]");
    var cmpEl = $("[data-compare]");
    var saveEl = $("[data-save]");
    var stockEl = $("[data-stock]");
    var strings = window.PLASTARA_STR || {};

    function selected() {
      return $$("[data-opt]", form).map(function (grp) {
        var b = $('[aria-pressed="true"]', grp);
        return b ? b.getAttribute("data-value") : null;
      });
    }

    function match(sel) {
      for (var i = 0; i < list.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] === null) continue;
          if (list[i].options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return list[i];
      }
      return null;
    }

    function apply() {
      var v = match(selected());
      if (!v) return;
      if (idInput) idInput.value = v.id;

      priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
      if (cmpEl) {
        var has = v.compare_at_price && v.compare_at_price > v.price;
        cmpEl.hidden = !has;
        if (has) cmpEl.textContent = formatMoney(v.compare_at_price);
        if (saveEl) {
          saveEl.hidden = !has;
          if (has) {
            saveEl.textContent = (strings.save || "Save {p}%")
              .replace("{p}", Math.round((1 - v.price / v.compare_at_price) * 100));
          }
        }
      }
      if (stockEl) {
        stockEl.className = "stock" + (v.available ? "" : " stock--out");
        stockEl.textContent = v.available
          ? (strings.in_stock || "In stock — ships in 1–2 business days")
          : (strings.sold_out || "Sold out");
      }
      var label = v.available ? (strings.add || "Add to cart") : (strings.sold_out || "Sold out");
      if (atc) { atc.disabled = !v.available; atc.textContent = label; }
      if (mAtc) { mAtc.disabled = !v.available; mAtc.textContent = label; }
      // reflect in URL so refresh/share keeps the variant
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
      // swap gallery to the variant image
      if (v.featured_media_id) {
        var t = $('[data-thumb="' + v.featured_media_id + '"]');
        if (t) t.click();
      }
    }

    $$("[data-opt]", form).forEach(function (grp) {
      $$("button[data-value]", grp).forEach(function (b) {
        on(b, "click", function () {
          $$("button[data-value]", grp).forEach(function (o) { o.setAttribute("aria-pressed", "false"); });
          b.setAttribute("aria-pressed", "true");
          var lab = $("[data-opt-current]", grp);
          if (lab) lab.textContent = b.getAttribute("data-value");
          apply();
        });
      });
    });

    on(form, "submit", function (e) {
      if (!drawer) return;                       // no drawer -> normal form post
      e.preventDefault();
      var qtyI = $("[data-qty]", form);
      addToCart(idInput.value, parseInt(qtyI && qtyI.value || "1", 10), atc);
    });
  }

  /* --------------------------------------------------------- sticky buy bar */
  function stickyBuy() {
    var bar = $("[data-mbuy]");
    var anchor = $("[data-buy-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (e) {
      bar.classList.toggle("is-on", !e[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
    on($("[data-mbuy-add]", bar), "click", function () {
      var atc = $("[data-atc]");
      if (atc) atc.click();
    });
  }

  /* ---------------------------------------------------------------- sort */
  function sorting() {
    var s = $("[data-sort]");
    if (!s) return;
    on(s, "change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("sort_by", s.value);
      u.searchParams.delete("page");
      window.location.href = u.toString();
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    reveals();
    announce();
    mobileNav();
    searchPanel();
    accordions();
    cart();
    qtyWidgets();
    gallery();
    variants();
    stickyBuy();
    sorting();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
